<template>
  <b-card no-body v-draggable class="popup app-ctrl">
    <b-card-header
      style="color: lightgrey; height: 25px;"
      class="pl-2 pb-0 pt-0"
      header-tag="div"
      header-bg-variant="dark"
    >
      <b-row class="mx-0 px-0">
        <b-col class="mx-0 px-0" cols="11">
          {{WaveName}} {{ $t('Webportal.CX.Margin.Healing') }}
        </b-col>
        <b-col class="mx-0 px-0" cols="1" style="text-align: right">
          <font-awesome-icon class="mx-1 clickable" :icon="['far', 'times']" @click="$emit('close')" />
        </b-col>
      </b-row>
    </b-card-header>
    <b-card-body >
      <b-card-text style="max-height: 500px; overflow: auto" v-bind:class="{ spinner: isLoading }">
        <div class="container" v-if="!finishedHealing">
          <!-- For the healing revisions will be created for the following checks:
          <ul>
            <template v-for="(survey, key) in surveys">
              <li v-bind:key="key">{{survey.ExternalSurveyInstanceId}}</li>
            </template>
          </ul> -->
          <p>{{ $t('Webportal.CX.Margin.HealingPopupText') }}</p>
          <p>{{ $t('Webportal.CX.Margin.HealingPopupText1') }}</p>
          <p>{{ $t('Webportal.CX.Margin.HealingPopupText2') }}</p>

          <h5>{{ $t('Webportal.CX.Margin.FAQHealingPeriodHealine') }}</h5>
          <ul>
            <li>{{ $t('Webportal.CX.Margin.H1HealingTime') }}</li>
            <li>{{ $t('Webportal.CX.Margin.H2HealingTime') }}</li>
          </ul>

          <p>{{ $t('Webportal.CX.Margin.Proceed?') }}</p>
          <div class="m-1">
            <button type="button" class="btn btn-primary" @click="createHealing()">
              {{ $t('Webportal.CX.Margin.StartHealingProcess') }}
            </button>
            <button type="button" class="btn btn-secondary" @click="$emit('close')">
              <font-awesome-icon :icon="['far', 'ban']" />
              {{ $t("Webportal.Cancel") }}
            </button>
          </div>
        </div>
        <div class="container" v-else>
          <p v-if="requestFail">{{ $t('Webportal.CX.Margin.CreateHealingFail') }}</p>
          <div v-else style="display:flex; flex-direction:column; text-align:center">
            <p>{{ $t('Webportal.CX.Margin.HealingSuccessfullyCreated') }}</p>
            <a
              href="/action/surveyrevisionexplorer"
              target="_blank"
            >
              <p>
                {{ $t('Webportal.CX.Margin.LinkToRevisions') }}
                <i class="mx-1 fas fa-external-link-alt"></i>
              </p>
            </a>
          </div>

          <button type="button" class="btn btn-secondary" @click="closeHealing()">{{ $t('Webportal.CX.Margin.Close') }}</button>
        </div>
      </b-card-text>
    </b-card-body>
  </b-card>
</template>

<script>
import EventBus from "@/services/EventBus";
import DashboardService from "@/services/DashboardService";
import { i18n, changeLocalization } from "@/i18n";

export default {
  name: "MarginHealPopup",

  components: {
    DashboardService,
  },
  props: {
    ClientLocationId: Number,
    WaveName: String,
    KpiGroup: Object,
    Year: Number,
    Brand: String
  },
  data() {
    return {
      isLoading: false,
      surveys: {},
      requestFail: false,
      finishedHealing: false,
    };
  },
  async mounted() {
    this.isLoading = true;
    await this.awaitGetSurveyData()
    .then(() => {
      this.isLoading = false;
    });
  },
  
  methods: {
    closeHealing() {
      if(this.requestFail == false) {
        EventBus.$emit("refresh-margin-card");
      } 
      this.$emit("close");
    },
    async createHealing() {
      this.isLoading = true;
      var surveyRevisions = [];
      for(var survey of Object.values(this.surveys)){
        if(survey.KpiResult < 100) {
          var surveyRevision = {
            "SurveyInstanceId": survey.SurveyInstanceId,
            "ExternalSurveyInstanceId": survey.ExternalSurveyInstanceId,
            "StatusId": 0,
            "Entries": [],
            "Remarks": "via Cx-Margin-Heal"
          };
          for (var question of survey.Questions) {
            if(question.IsPositiveAnswer == false) {
              var revisionEntry = {
                "SurveyQuestionId": question.SurveyQuestionId,
                "QuestionNumber": question.QuestionNumber,
                "QuestionText": question.QuestionText,
                "Remarks": "via Cx-Margin-Heal"
              };
              surveyRevision.Entries.push(revisionEntry);
            }
          };
          if(surveyRevision.Entries.length > 0) {
            surveyRevisions.push(surveyRevision);
          };
        };
      };
      var body = {
        "SurveyRevisions": surveyRevisions,
        "Brand": this.Brand,
        "ClientLocationId": this.ClientLocationId
      };
      if(surveyRevisions.length > 0) {
        await DashboardService.CreateMarginHealing(body)
        .then(() => {
          this.finishedHealing = true;
        })
        .catch((err) => {
          console.warn(err);
          this.requestFail = true;
          this.finishedHealing = true;
        })
        .finally(() => {
          this.isLoading = false;
        })
      } else {
        this.requestFail = true;
        this.finishedHealing = true;
        this.isLoading = false;
      }
    },
    async awaitGetSurveyData() {
      await Promise.all(this.KpiGroup.Items.map(async (kpi) => {
        await this.getSurveyData(kpi);
      }));
    },
    async getSurveyData(kpi) {
      var surveyWave = kpi.SurveyWave.find(x => x.Name == this.WaveName);
      if(surveyWave == undefined) {
        return;
      };
      var body = {
        "ClientLocationId": this.ClientLocationId,
        "SurveyKpiIds": kpi.SurveyKpiIds, 
        "SurveyWaveIds": surveyWave.SurveyWaveIds,
        "ScenarioName": surveyWave.Scenario,
        "LocalizationId": i18n.locale,
        "Year": this.Year
      };
      await DashboardService.GetSurveyKpiQuestionAndAnswerTexts(body)
      .then((res) => {
        if(!res.data) { throw Error("Could not query questions and answers for", body)};

        // collect surveys
        for (var index in res.data) {
          if (this.surveys[res.data[index].SurveyInstanceId] == undefined){
            this.surveys[res.data[index].SurveyInstanceId] = {};
          };
          this.surveys[res.data[index].SurveyInstanceId] = {
            "ExternalSurveyInstanceId": res.data[index].ExternalSurveyInstanceId,
            "SurveyInstanceId": res.data[index].SurveyInstanceId,
            "Questions": [],
            "Threshold": 75
          };
        };
        // collect surveyQuestions
        for (var index in res.data) {
          this.surveys[res.data[index].SurveyInstanceId].Questions.push({
            "IsPositiveAnswer": res.data[index].IsPositiveAnswer,
            "QuestionNumber": res.data[index].QuestionNumber,
            "QuestionText": res.data[index].QuestionText,
            "SurveyAnswerText": res.data[index].SurveyAnswerText,
            "SurveyQuestionId": res.data[index].SurveyQuestionId
          });
        };
      })
      .catch(error => console.warn("Error while loading marginHealPopup: " + error))
      .finally(() => {
        this.calculateSurveyInstanceKpiResult();
        return;
      })
    },
    calculateSurveyInstanceKpiResult() {
      var questionCount;
      var positiveQuestionCount;
      for (const surveyId in this.surveys) {
        questionCount = 0;
        positiveQuestionCount = 0;
        for (const index in this.surveys[surveyId].Questions) {
          questionCount++;
          if(this.surveys[surveyId].Questions[index].IsPositiveAnswer == true) {
            positiveQuestionCount++;
          };
        };
        this.surveys[surveyId].KpiResult = (positiveQuestionCount / questionCount) * 100;
      }      
    }
  }
};
</script>

<style scoped>
.popup {
  box-shadow: 3px 3px 13px -3px var(--border-color-secondary);
  border: none;
  position: fixed !important;
  width: 650px;
  min-height: 55px;
  max-height: 90%;
  overflow: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.container {
  display: flex;
  flex-direction: column;
}
</style>